import React from 'react';
import { motion } from 'framer-motion';
import { Activity, Brain, Zap } from 'lucide-react';
const painPoints = [{
  icon: Activity,
  title: 'Dominancia Estrogénica',
  description: 'Acumulación de grasa en caderas y parte baja del abdomen. Tu hígado no puede procesar el exceso de estrógenos.'
}, {
  icon: Brain,
  title: 'Resistencia a la Leptina',
  description: 'Tu cerebro ya no escucha la señal de saciedad. Comes más de lo que necesitas sin darte cuenta.'
}, {
  icon: Zap,
  title: 'Cortisol Elevado',
  description: 'El estrés crónico se convierte en grasa visceral peligrosa alrededor de tus órganos.'
}];
export function EmpathySection() {
  return <section className="py-20 bg-[#FFF7ED]" data-id="element-32">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-33">
        <div className="max-w-3xl mx-auto text-center mb-16" data-id="element-34">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-3xl md:text-4xl font-bold text-[#064E3B] mb-6 leading-tight" data-id="element-35">
            El Muro de los 40: Por qué las dietas de tus 20s y 30s ya no
            funcionan
          </motion.h2>
          <p className="text-lg text-[#6B7280]" data-id="element-36">
            A partir de los 40, tu cuerpo entra en un estado de inflexibilidad
            metabólica. No es falta de voluntad, es un desbalance hormonal
            conocido como el Triángulo del Estancamiento.
          </p>
        </div>

        <div className="relative max-w-5xl mx-auto" data-id="element-37">
          {/* Connecting lines for desktop */}
          <div className="hidden md:block absolute top-1/2 left-0 w-full h-0.5 bg-[#F97316]/20 -z-10 transform -translate-y-1/2" data-id="element-38"></div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-39">
            {painPoints.map((point, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.2
          }} className="bg-white p-8 rounded-xl border border-orange-100 shadow-sm relative overflow-hidden" data-id="element-40">
                <div className="absolute top-0 left-0 w-full h-1 bg-[#F97316]" data-id="element-41"></div>

                <div className="w-16 h-16 bg-[#FFF7ED] rounded-full flex items-center justify-center mb-6 text-[#F97316] mx-auto" data-id="element-42">
                  <point.icon size={32} strokeWidth={2} data-id="element-43" />
                </div>

                <h3 className="text-xl font-bold text-[#1F2937] mb-3 text-center" data-id="element-44">
                  {point.title}
                </h3>

                <p className="text-[#6B7280] leading-relaxed text-center" data-id="element-45">
                  {point.description}
                </p>
              </motion.div>)}
          </div>

          <div className="text-center mt-12" data-id="element-46">
            <span className="inline-block bg-[#064E3B] text-white px-6 py-2 rounded-full text-sm font-bold uppercase tracking-wider shadow-lg" data-id="element-47">
              Triángulo del Estancamiento
            </span>
          </div>
        </div>
      </div>
    </section>;
}